var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-start"},[_c('div',{staticClass:"cta",on:{"click":function($event){return _vm.$emit('input', 'path')}}},[_c('i'),_c('span',[_vm._v("На старт!")])])])}
var staticRenderFns = []

export { render, staticRenderFns }